import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import {
	getIsSoftwareThemingEnabled,
	getIsSoftwareThemingM2Enabled,
} from '@atlassian/jira-project-theme-providers/src/utils/getIsSoftwareThemingEnabled.tsx';
import {
	SOFTWARE_THEME_ROUTES,
	SOFTWARE_THEME_ROUTES_M2,
	SOFTWARE_FULL_THEME_ROUTES,
	SOFTWARE_FULL_THEME_ROUTES_M2,
} from './constants.tsx';

export const useCurrentRoute = createRouterSelector((state) => state.route.name);

export const useSoftwareProjectTheming = () => {
	if (!getIsSoftwareThemingEnabled()) {
		return {
			hasSoftwareTheming: false,
			isSoftwareFullTheming: false,
			isSoftwareProject: false,
		};
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { data: projectData } = useProjectContext();
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const currentRoute = useCurrentRoute();

	const isSoftwareProject = projectData?.projectType === SOFTWARE_PROJECT;

	// temporarily disable theming for calendar
	// the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
	const isSoftwareCalendarRoute =
		currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';

	const hasSoftwareTheming = getIsSoftwareThemingM2Enabled()
		? isSoftwareProject && SOFTWARE_THEME_ROUTES_M2.includes(currentRoute)
		: isSoftwareProject && SOFTWARE_THEME_ROUTES.includes(currentRoute) && !isSoftwareCalendarRoute;
	const isSoftwareFullTheming = getIsSoftwareThemingM2Enabled()
		? hasSoftwareTheming && SOFTWARE_FULL_THEME_ROUTES_M2.includes(currentRoute)
		: hasSoftwareTheming && SOFTWARE_FULL_THEME_ROUTES.includes(currentRoute);

	return {
		hasSoftwareTheming,
		isSoftwareFullTheming,
		isSoftwareProject,
	};
};
